import React from "react";
import LottieBox from "components/styled/lottieBox/LottieBox";
import loading from "assets/animations/loading.json";

const LoadingView = () => {
  const style = {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
  };

  return (
    <div style={style}>
      <LottieBox src={loading} size={60} />
    </div>
  );
};

export default LoadingView;
